import { useState } from "react";
import {
  ChevronLeft,
  ChevronRight,
  LayoutDashboard,
  ShoppingCart,
  History,
  Package,
  User,
  UserRoundPen,
  Star,
  Truck,
  House,
  SquarePen,
  ShoppingBasket,
  FileClock,
  LogOut,
  EqualNot,
} from "lucide-react";

import { Link, NavLink, useNavigate } from "react-router-dom";
import { useUserServices } from "../context/DealerProfile";

export default function Sidebar() {
  const [expanded, setExpanded] = useState(true);

  const navigate = useNavigate();

  const {
    dealerDetail: { accountName, dealerName, crmUserDetail },
  } = useUserServices();

  const handleLogout = () => {
    const redirectURL = "/__catalyst/auth/login";
    window.catalyst.auth.signOut(redirectURL);
  };

  // useEffect(() => {
  //   function parseQueryToObj(url) {
  //     // Find the position of '?'
  //     const queryStartIndex = url.indexOf("?");

  //     // If '?' is found, extract the part after it
  //     if (queryStartIndex !== -1) {
  //       const queryString = url.substring(queryStartIndex + 1);

  //       // Split the query string into key-value pairs
  //       const pairs = queryString.split("&");
  //       const queryObj = {};

  //       // Iterate over each pair and split into key and value
  //       pairs.forEach((pair) => {
  //         const [key, value] = pair.split("=");
  //         if (key) {
  //           queryObj[decodeURIComponent(key)] = decodeURIComponent(value || "");
  //         }
  //       });

  //       return queryObj;
  //     }

  //     // If no query string is found, return an empty object
  //     return {};
  //   }

  //   // Example usage
  //   const url = window.location.href;
  //   const parsedQueryObj = parseQueryToObj(url);
  //   const appUrl = parsedQueryObj?.["some_url"];
  //   console.log({ parsedQueryObj });
  //   if (appUrl) {
  //     console.log(appUrl);
  //     return navigate(`/${appUrl.replace("/app", "")}`, { replace: true });
  //   }
  // },[navigate]);

  const routes = [
    { name: "Dashboard", icon: LayoutDashboard, path: "/dashboard" },
    { name: "Products", icon: Package, path: "/products" },
    { name: "Request For Order", icon: ShoppingCart, path: "/purchase-order" },
    { name: "Order History", icon: History, path: "/order-history" },
    { name: "Favourite Products", icon: Star, path: "/favourite-item" },
    { name: "Billing Addresses", icon: House, path: "/billing-adresses" },
    { name: "Shipping Addresses", icon: Truck, path: "/shipping-adresses" },
    { name: "Sales Return Request", icon: ShoppingBasket, path: "/sales-return" },
    { name: "Return History", icon: FileClock, path: "/return-history" },
    { name: "Cancel Request", icon: EqualNot, path: "/cancel-order" },
    ...(dealerName?.id === null || crmUserDetail.Is_Admin      
      ? [{ name: "Change Request", icon: SquarePen, path: "/change-request" }]
      : []),
    { name: "Profile", icon: UserRoundPen, path: "/profile" },
  ];

  return (
    <aside
      className={`h-screen bg-gray-800 custom-scroll-bar text-white transition-all overflow-y-auto duration-300 ease-in-out ${
        expanded ? "w-64" : "w-20"
      }`}
    >
      <div className="flex flex-col h-screen justify-between">
        <div className="p-4 flex items-center justify-between">
          <Link to={"/"}>
            <div className="flex items-center space-x-2">
              <div className="w-8 h-8 border rounded-full overflow-hidden">
                <img src={`favicon.png`} alt="logo" />
              </div>
              {expanded && <span className="font-bold">Channel Partner Portal</span>}
            </div>
          </Link>
          <button
            onClick={() => setExpanded(!expanded)}
            className="text-white hover:bg-gray-700 font-bold pl-2"
          >
            {expanded ? (
              <ChevronLeft className="h-4 w-4" />
            ) : (
              <ChevronRight className="h-4 w-4" />
            )}
          </button>
        </div>

        {/* Navigation routes */}
        <nav className="flex-grow my-5 h-80 overflow-y-auto">
          <ul className="space-y-2 h-20">
            {routes.map((route) => (
              <li key={route.path}>
                <NavLink
                  to={route.path}
                  className={({ isActive }) => {
                    // console.log({ isActive });
                    return `flex items-center px-4 py-2 text-sm hover:bg-gray-700
                    ${isActive ? "bg-gray-700" : ""}
                    ${expanded ? "justify-start space-x-4" : "justify-center"}`;
                  }}
                >
                  <route.icon className="h-5 w-5" />
                  {expanded && <span>{route.name}</span>}
                </NavLink>
              </li>
            ))}

            <li key="sometingelse" onClick={handleLogout}>
              <p
                className={`flex cursor-pointer text-red-600 items-center px-4 py-2 text-sm hover:bg-red-900 hover:text-white
                    ${expanded ? "justify-start space-x-4" : "justify-center"}`}
              >
                <LogOut className="h-5 w-5" />
                {expanded && <span>Logout</span>}
              </p>
            </li>
          </ul>
        </nav>

        {/* User information at the bottom */}
        <div
          className={`p-4 border-t border-gray-700
            ${
              expanded
                ? "flex items-center space-x-4"
                : "flex flex-col items-center space-y-2"
            }`}
        >
          <div className="w-10 h-10 bg-gray-600 rounded-full flex items-center justify-center">
            <Link to="/profile">
              <User className="h-6 w-6" />
            </Link>
          </div>
          {expanded && (
            <div className="flex-grow">
              <p className="text-sm font-medium">{`${accountName?.name}`}</p>
              <p className="text-xs text-gray-400">{dealerName?.name}</p>
            </div>
          )}
        </div>
      </div>
    </aside>
  );
}
